
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 0H.5a.5.5 0 00-.5.5v23a.5.5 0 00.5.5h5.75a.5.5 0 00.5-.5V6.75H23.5a.5.5 0 00.5-.5V.5a.5.5 0 00-.5-.5zM1 12.5h4.75v4.75H1zm4.75-1H1V6.75h4.75zm0 11.5H1v-4.75h4.75zm1-22h4.75v4.75H6.75zm5.75 0h4.75v4.75H12.5zM23 5.75h-4.75V1H23z"}}),_c('path',{attrs:{"d":"M15.36 8.9a.5.5 0 00-.55-.1.5.5 0 00-.18.12l-2.48 2.48a.5.5 0 00.7.7l1.64-1.63v1.62c0 3.13-2.01 5.67-4.5 5.67a.5.5 0 000 1c3.04 0 5.5-3 5.5-6.67v-1.64l1.66 1.66a.5.5 0 00.7-.71z"}})])
          )
        }
      }
    